export function formatDate(dateStr) {
    if (dateStr == null) return '-';

    dateStr = dateStr.replace(
        /\.(\d{3})\d+/,
        ".$1"
    );

    const date = new Date(dateStr)

    return new Intl.DateTimeFormat("en-GB", {
        dateStyle: "medium",
        timeStyle: "short",
    }).format(date);
}

export function formatBytes(bytes) {
    if (bytes === 0) return "0 B";

    const k = 1024;
    const sizes = ["B", "KB", "MB", "GB", "TB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return `${Math.round(bytes / Math.pow(k, i))} ${sizes[i]}`;
}